import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import history from '../../history';
import routes from '../../utils/routes';

import ManageQuestionPresentation from './manage-question-presentation';

import {
    asyncUpdateQuestion,
    changeQuestionToManage,
    fetchAsyncQuestionToManage,
} from './manage-question.actions';

class ManageQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            originalQuestion: {},
            title: '',
            options: [],
            titleOption: '',
            checkedOption: false,
            checkedEnableQuestion: false,
            hasOption: false,
            optionsValid: false,
            optionsValidToAddOptions: false,
            questionIdToManage: null,
            editMode: false,
            originalOption: {},
            editTitleOption: '',
            checkedCorrectOption: false,
        };
    }

    componentDidMount() {
        const { fetchAsyncQuestionToManage, match } = this.props;
        const questionId = match.params.question_id;
        fetchAsyncQuestionToManage(questionId);
        this.setState({ questionIdToManage: questionId });
    }

    componentDidUpdate(prevProps) {
        const { manageQuestion } = this.props;
        if (manageQuestion.id !== prevProps.manageQuestion.id) {
            const defaultQuestion = this.createStateDefault(manageQuestion);
            this.checkOptionsValid(defaultQuestion.options);
            this.setState({
                originalQuestion: manageQuestion,
                ...defaultQuestion,
            });
        }
    }

    componentWillUnmount() {
        const { changeQuestionToManage } = this.props;
        changeQuestionToManage({});
    }

    createStateDefault(question) {
        const defaultQuestion = {};
        Object.assign(defaultQuestion, {
            checkedEnableQuestion: question.enabled,
        });
        Object.assign(defaultQuestion, { title: question.title });

        const newOptions = question.options.map(option => {
            const isQuestionCorrect =
                option.id === question.correct_option_id ? true : false;
            return {
                enabled: option.enabled,
                id: option.id,
                title: option.title,
                correct: isQuestionCorrect,
            };
        });

        Object.assign(defaultQuestion, {
            options: newOptions,
        });

        return defaultQuestion;
    }

    checkOptionsValid(options) {
        let optionsValid = false,
            optionsValidToAddOptions = false;
        const validOptions = options.filter(
            option => !option.removed && option.enabled,
        );
        const hasOptionCorrectIndex = options.findIndex(
            option => option.correct,
        );
        if (
            validOptions.length >= 2 &&
            validOptions.length <= 10 &&
            hasOptionCorrectIndex >= 0
        ) {
            optionsValid = true;
        }

        if (validOptions.length < 10) {
            optionsValidToAddOptions = true;
        }
        this.setState({
            optionsValid: optionsValid,
            optionsValidToAddOptions: optionsValidToAddOptions,
        });
    }

    handleInputText(target) {
        const { options } = this.state;
        let newHasOption = false;
        if (
            target.name === 'titleOption' ||
            target.name === 'editTitleOption'
        ) {
            const indexTitleOptionEqual = options.findIndex(
                option => (option.title).trim().toUpperCase() === (target.value).trim().toUpperCase()
            );
            if (indexTitleOptionEqual >= 0) {
                newHasOption = true;
            }
        }

        this.setState({ [target.name]: target.value, hasOption: newHasOption });
    }

    handleItemsOptionQuestion(question) {
        const options = this.state.options;
        const findIndex = options.findIndex(
            item => item.title === question.title,
        );

        const visibleOptions = options.filter(
            option => !option.removed && option.enabled,
        );
        if (visibleOptions.length < 10 && findIndex < 0) {
            const serializeOptions = options.map(option => ({
                ...option,
                correct: question.correct ? false : option.correct,
            }));
            const newOptions = [...serializeOptions, question];

            this.checkOptionsValid(newOptions);
            this.setState({
                options: newOptions,
                titleOption: '',
                checkedOption: false,
            });
        }
    }

    handleRemoveItemsOptionQuestion(title) {
        const options = this.state.options;
        const checkItem = options.find(option => option.title === title);
        let newOptions = [];
        if (checkItem.id) {
            newOptions = options.map(option => {
                const newOption = {};
                Object.assign(newOption, option);
                if (option.title === title) {
                    Object.assign(newOption, { removed: true, enabled: false });
                    if (option.correct) {
                        Object.assign(newOption, { correct: false });
                    }
                }

                return newOption;
            });
        } else {
            newOptions = options.filter(option => option.title !== title);
        }

        this.checkOptionsValid(newOptions);
        this.setState({
            options: [...newOptions],
        });
    }

    handleSelectCorrectOptionQuestion(title) {
        const { options } = this.state;
        const newOptions = options.map(option => {
            return {
                ...option,
                correct: option.title === title ? true : false,
            };
        });
        this.checkOptionsValid(newOptions);
        this.setState({ options: [...newOptions] });
    }

    handleEnableItemsOptionQuestion(title, value) {
        const options = this.state.options;

        const newOptions = options.map(option => {
            return {
                ...option,
                correct:
                    option.title === title && option.correct && !value
                        ? false
                        : option.correct,
                enabled: option.title === title ? value : option.enabled,
            };
        });

        this.checkOptionsValid(newOptions);
        this.setState({ options: [...newOptions] });
    }

    handleUpdateQuestion({ question, options, enabled }) {
        const { questionIdToManage } = this.state;
        this.props.asyncUpdateQuestion({
            questionId: questionIdToManage,
            question,
            options,
            enabled,
        });
    }

    gotoBack() {
        history.push(routes.QUESTIONS_DATABASE);
    }

    enableEditMode({ title, correct }) {
        this.setState({
            editMode: true,
            originalOption: {
                title: title,
                correct: correct,
            },
            editTitleOption: title,
            checkedCorrectOption: correct,
        });
    }

    saveOptionEditMode({ title, correct }) {
        const { originalOption, options } = this.state;
        if (Object.keys(originalOption).length > 0) {
            const serializeOptions = options.map(option => {
                if (originalOption.title === option.title) {
                    return { ...option, title, correct };
                }

                return {
                    ...option,
                    correct: correct ? false : option.correct,
                };
            });

            this.setState({
                options: serializeOptions,
                editMode: false,
                originalOption: {},
                editTitleOption: '',
                checkedCorrectOption: false,
            });
        }
    }

    disableEditMode() {
        this.setState({
            editMode: false,
            originalOption: {},
            editTitleOption: '',
            checkedCorrectOption: false,
        });
    }

    render() {
        const { loading } = this.props;
        const {
            title,
            options,
            titleOption,
            checkedOption,
            checkedEnableQuestion,
            hasOption,
            optionsValid,
            optionsValidToAddOptions,
            editMode,
            editTitleOption,
            checkedCorrectOption,
        } = this.state;
        return (
            <ManageQuestionPresentation
                loading={loading}
                onCancel={this.gotoBack.bind(this)}
                handleUpdateQuestion={this.handleUpdateQuestion.bind(this)}
                handleSelectCorrectOptionQuestion={this.handleSelectCorrectOptionQuestion.bind(
                    this,
                )}
                handleRemoveItemsOptionQuestion={this.handleRemoveItemsOptionQuestion.bind(
                    this,
                )}
                title={title}
                handleInputText={this.handleInputText.bind(this)}
                handleItemsOptionQuestion={this.handleItemsOptionQuestion.bind(
                    this,
                )}
                options={options}
                titleOption={titleOption}
                checkedOption={checkedOption}
                checkedEnableQuestion={checkedEnableQuestion}
                handleEnableItemsOptionQuestion={this.handleEnableItemsOptionQuestion.bind(
                    this,
                )}
                hasOption={hasOption}
                optionsValid={optionsValid}
                optionsValidToAddOptions={optionsValidToAddOptions}
                editMode={editMode}
                editTitleOption={editTitleOption}
                checkedCorrectOption={checkedCorrectOption}
                enableEditMode={this.enableEditMode.bind(this)}
                disableEditMode={this.disableEditMode.bind(this)}
                saveOptionEditMode={this.saveOptionEditMode.bind(this)}
            />
        );
    }
}

const mapStateToProps = ({ manageQuestion, onlineTests }) => ({
    manageQuestion: manageQuestion.manageQuestion,
    loading: onlineTests.loading,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            asyncUpdateQuestion,
            changeQuestionToManage,
            fetchAsyncQuestionToManage,
        },
        dispatch,
    );

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManageQuestion),
);



// WEBPACK FOOTER //
// ./src/components/manage-question/manage-question.js